export default __webpack_public_path__ + "static/media/Mark-6-Suit-05.7e9d9b2f.jpg";